import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from "@services/authentication/authentication.service";
import { MS_GRAPH_URL } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class CustomHttpInterceptorBearer implements HttpInterceptor {

  constructor(private authenticationService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = '';

    if (request.url.includes(MS_GRAPH_URL)) {
      token = this.authenticationService.extractMSALTokenAccess();
    } else {
      token = this.authenticationService.getToken();
    }

    request = request.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });

    return next.handle(request).pipe(map((data) => data));
  };

}
